import { useState, useEffect } from 'react';

import { reportData } from '../../const/report-example';
import { REPORT_OPTIONS } from '../../const';
import { getNumberAsString, getWorkingWeek } from '../../helpers';
import Tabs from '../report-tabs';
import '../../assets/styles/report.scss';

const ExampleOfReport = ({ onClose }) => {
  const [activeOption, setActiveOption] = useState('');
  const [tabButtons, setTabButtons] = useState([]);
  const [designPrice, setDesignPrice] = useState('€3-5,3K');
  const [designTime, setDesignTime] = useState('5');
  const [days, setDays] = useState({ min: 0, max: 0 });

  // https://laestimator.ai/report/CRZ0eIq_D2n5n_xITRt-g

  useEffect(() => {
    const buttonsList = [];
    let priceOfDesign = '';
    let timeOfDesign = '';

    REPORT_OPTIONS.forEach((item) => {
      const match = reportData.results[item.id];
      let newItem;

      if (!match) {
        newItem = item;
      } else {
        newItem = {
          ...item,
          cost: getNumberAsString(+match.price_min, +match.price_max),
        };

        if (match.design_min && match.design_max) {
          priceOfDesign = getNumberAsString(
            +match.design_min,
            +match.design_max,
          );
        }

        // add values to Design tab
        if (match.design_days_min && match.design_days_max) {
          let week = '';

          setDays({
            min: +match.design_days_min,
            max: +match.design_days_max,
          });

          if (match.design_days_min === match.design_days_max) {
            week = getWorkingWeek(+match.design_days_max);
          } else {
            week = `${getWorkingWeek(
              +match.design_days_min,
            )}–${getWorkingWeek(+match.design_days_max)}`;
          }

          if (!timeOfDesign || timeOfDesign != week) {
            timeOfDesign = week;
            setDesignTime(week);
          }
        }
      }

      buttonsList.push(newItem);
    });

    // add priceOfDesign to tab button
    if (priceOfDesign) {
      setDesignPrice(priceOfDesign);
      const index = buttonsList.findIndex((item) => item.id === 'design');

      if (index !== -1) {
        buttonsList[index] = {
          id: 'design',
          value: 'UI/UX design',
          cost: priceOfDesign,
        };
      }
    }

    setTabButtons(buttonsList);
  }, []);

  useEffect(() => {
    if (!activeOption) setActiveOption(REPORT_OPTIONS[0]);
  }, [activeOption]);

  const onSetActive = (e) => {
    const id = e.target.id;
    const currentOption = REPORT_OPTIONS.find((option) => id === option.id);
    if (currentOption) {
      setActiveOption(currentOption);
    }
  };

  return (
    <div className="report-example__container">
      <div>
        <button
          type="button"
          className="btn-md-close"
          onClick={onClose}
          title="Close"
        />
        <div className="report-modal">
          <div className="report-page__heading-buttons">
            <div className={`report-page__heading`}>
              <div>
                <h2>
                  Booking <strong>app Estimations</strong>
                </h2>
                <p>We’ve carefully analyzed your responses and calculated</p>
                <div className="copy-link-btn__wrapper">
                  <button type="button" className="copy-link-btn ic-copy-link">
                    <div className="copy-link-btn__tooltip">
                      Copy report link
                    </div>
                  </button>
                </div>
              </div>
              <div className="report-page__heading__link-wrapper">
                <button className="primaryFatLink ic-consultation" disabled>
                  Book free consultation
                </button>
                <p>to get 100% accuracy estimations</p>
              </div>
            </div>

            <div className={`report-options-fieldset`}>
              <legend>Choose an option:</legend>
              <div className="options-wrapper">
                <div>
                  {tabButtons.length > 0 &&
                    tabButtons.map((option) => (
                      <div key={option.id} className="report-option-btn-group">
                        <button
                          type="button"
                          id={option.id}
                          className={`ic-check${
                            activeOption.id === option.id ? ' active' : ''
                          }`}
                          onClick={onSetActive}
                        >
                          {option.value}
                          <span>{option.cost}</span>
                        </button>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>

          <div>
            <section
              className="report-page__tabs-block on-report-popup"
              id="report-tabs--js"
            >
              <Tabs
                activeOption={activeOption}
                results={reportData.results}
                haveDesign={reportData.have_design}
                designPrice={designPrice}
                designTime={designTime}
                days={days.min ? days : ''}
              />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExampleOfReport;
